exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".TextBox__root.TextBox__invalid textarea{border-color:#b00}.TextBox__root input.TextBox__isSearch{padding-left:2.5em}.TextBox__root textarea{resize:none}\n", "", {"version":3,"sources":["/home/runner/work/greenline-web/greenline-web/web/js/components/common/TextBox/TextBox.scss"],"names":[],"mappings":"AAAA,yCAAuB,iBAAiB,CAAC,uCAAqB,kBAAkB,CAAC,wBAAe,WAAW,CAAC","file":"TextBox.scss","sourcesContent":[".root.invalid textarea{border-color:#b00}.root input.isSearch{padding-left:2.5em}.root textarea{resize:none}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"root": "TextBox__root",
	"invalid": "TextBox__invalid",
	"isSearch": "TextBox__isSearch"
};